var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.generatedComponent,{tag:"span",staticClass:"ni-pgtr-btn",class:{
		'current': _vm.isCurrent,
	},attrs:{"disabled":_vm.disabled,"to":_vm.routeNext},on:{"click":function($event){return _vm.goTo(_vm.index)}}},[(_vm.icon)?_c('nice-icon',_vm._b({attrs:{"disabled":_vm.disabled}},'nice-icon',_vm.icon,false)):_c('span',{staticClass:"ni-pgtr-index"},[_vm._v(_vm._s(_vm.index))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }